import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
    name: ''
  }
})

export default {
  [types.SET_HOTEL] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.hotel = payload
  },
  [types.SET_HOTELS] (state, payload) {
    state.hotels = payload.data
    state.pagination = payload.meta.pagination
  }
}
